<script setup lang="ts">
import { useClientProfile } from "@/app/composables/useClientProfile";
import PersonalDetailsCard from "@/app/components/settings/PersonalDetailsCard.vue";
import PasswordChangeCard from "@/app/components/settings/PasswordChangeCard.vue";
import SettingsPageLayout from "@/app/components/settings/SettingsPageLayout.vue";
import SettingsSection from "@/app/components/settings/SettingsSection.vue";

const { profile, isLoading, error, refetch } = useClientProfile();
</script>

<template>
    <SettingsPageLayout
        title="Settings"
        :is-loading="isLoading"
        :error="error"
        :on-retry="refetch"
    >
        <template v-if="profile">
            <SettingsSection
                title="Personal Details"
                description="This is your profile details that experts will see when communicating with you."
            >
                <PersonalDetailsCard />
            </SettingsSection>

            <SettingsSection
                title="Change Password"
                description="Update your password to keep your account secure."
            >
                <PasswordChangeCard />
            </SettingsSection>
        </template>
    </SettingsPageLayout>
</template>
